(function(){

    const fontClorOptions = document.querySelectorAll('.font_color_options input[type=radio]');
    
    const fontColorProperty = document.getElementById('font_color_line_item');

    if(fontClorOptions !== null || fontColorProperty !== null ) {

        for (var i = 0, length = fontClorOptions.length; i < length; i++) {
            if (fontClorOptions[i].checked) {
            fontColorProperty.value = fontClorOptions[i].value;
        
            // Only one radio can be logically checked, don't check the rest
            break;
            }
        }

    }

    const fontColorOptionChange = (e) => {
        fontColorProperty.value = e.target.value;
    };

    fontClorOptions.forEach((option) => {
        option.addEventListener('change', fontColorOptionChange);
    });

})();